import { render } from "./ClinicIntegrationsTab.vue?vue&type=template&id=06ff4430&scoped=true"
import script from "./ClinicIntegrationsTab.js?vue&type=script&lang=js&external"
export * from "./ClinicIntegrationsTab.js?vue&type=script&lang=js&external"

import "./ClinicIntegrationsTab.vue?vue&type=style&index=0&id=06ff4430&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ff4430"]])

export default __exports__